import { Grid as MuiGrid, GridProps as MuiGridProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import CommonConstants from '@Constants/common.constants';

export const Container = styled(MuiGrid)<MuiGridProps>(
  ({ theme: { colors, spacing, palette, customVars } }) => ({
    height: '100vh',
    flexWrap: 'nowrap',
    overflow: 'hidden',

    '& .sideMenu': {
      flex: `0 0 ${spacing(CommonConstants.SIDE_MENU_MAX_WIDTH)}`,
      height: '100%',
      backgroundColor: colors.sideBarMenu,
      overflowY: 'auto',
    },

    '& .header': {
      height: spacing(5.6),
      background: palette.common.white,
      boxShadow: customVars.headerShadow,
    },

    '& .main': {
      position: 'relative',
      height: `calc(100% - ${spacing(5.6)})`,
      backgroundColor: palette.background.paper,
      overflowY: 'auto',
    },
  })
);
